import React, {useEffect, useRef, useState} from 'react'
import { useSetState } from 'ahooks'
import {useNavigate, useSearchParams} from 'react-router-dom'

import {SActionBtn, SAlert, SBack, SLowcodeList, STableActions, STags} from 'shj-components'

import { config } from './config.tsx'
import styles from '@/pages/baseProduct/schemeProductList/index.module.less'
import {getPackTreeNodeList, getProductEnums} from '@/services/product.ts'

import {getAllCompany} from '@/services/homeService.ts'
import {isArray} from "lodash-es";
import KeepAlive from "react-activation";
import CombinationDetails from "@/pages/baseProduct/schemeProductList/components/CombinationDetails";

const  SchemeProductDetails = () => {
  const [searchParams] = useSearchParams({})
  const packModelName = searchParams.get('packModelName')
  const id = searchParams.get('packModelId')
  const listId = searchParams.get('listId')
  const navigate = useNavigate()
  const listRef = useRef();
  const companyRef  = useRef();
  const [state, setState] = useSetState({
    companyList: [],
  })
  const [currentRecord, setCurrentRecord] = useState<any>({});
  const [isCombinationDetails, setIsCombinationDetails] = useState(false);
  const [searchInitialValues, setSearchInitialValues] = useState({});

  useEffect(() => {
    if(isArray(state.companyList)&&state.companyList?.length>0){
      reloadFn(state.companyList)
    }
  },[state.companyList])

  const reloadFn = (companyList)=>{
    const shopId = companyList[0]?.id||"";
    listRef?.current?.getSearch()?.setFieldsValue({shopId})
    listRef?.current?.reloadAndSearch()
    setSearchInitialValues({
      shopId
    })
  }

  const fetchList = ({query}) => {
    if (!id||(!query?.shopId)) return Promise.reject()
    return new Promise((resolve, reject) => {
      const data = {
        "orderBys": [{"columnName": "id"}],
        sourceId:id,
        querySku: true, //写死
        queryReturnNode: true,
        expirationTimeIsNull: true,
        ...query,
      }
      data.shopIds = ["0",data?.shopId||""];
      // 后端约定有查询条件不返回树形
      if(data?.dtlNameLike||data?.busType){
        data.queryReturnNode = false;
      }
      delete data.shopId;
      getPackTreeNodeList({data})
        .then(res => {
          console.log('公司列表...', res||[])
          return resolve({ records: isArray(res)?res:[] })
        }).catch(reject)
    })
  }
  const onStandDetail = (record) => {
    const shopId = listRef?.current?.getSearch()?.getFieldValue('shopId');
    navigate(`/config/standardConfigDetails/?busId=${record?.busId||""}&companyId=${shopId}&listId=${listId}&nodeName=${encodeURIComponent(record?.nodeName||"")}`)
  }
  const onDetail = (obj) => {
    const companyId = listRef?.current?.getSearch()?.getFieldValue('shopId');
    setIsCombinationDetails(true)
    setCurrentRecord({
      id:obj?.productSku?.productId||"",
      companyId,
      searchOrgId:""
    });
  }

  const getOptions = async () => {
    return new Promise(resolve => {
      Promise.all([
        getAllCompany(),
        getProductEnums('com.shj.saas.plus.product.enums.PackTreeNodeTypeEnum')
      ]).then((res: any) => {
        const obj = {
          companyList: res[0],
          busTypeList: res[1],
        }
        // 过滤类型为房型
        obj.busTypeList = obj.busTypeList.filter((item)=>{
          return item.key !== 'PRD_HOUSE_TYPE';
        })
        companyRef.current =res[0];
        setState({  ...obj})
        resolve({ ...obj })
      })
    })
  }

  const onSearchReset = () => {
    const companyList = companyRef?.current || [];
    if(isArray(companyList)&&companyList?.length>0){
      reloadFn(companyList)
    }
  }

  const extensions = {
    onSearchReset,
    request: { fetchList, getOptions },
    customRender: {
      enableRender(_, record: Record<string, any>) {
        if(record?.productSku){
          const enabled = record?.productSku?.enabled;
          return (
              <STags itemKey='' label={enabled ? '启用' : '禁用'} fontColor={enabled ? '#00A865' : '#EB3723'} bgColor={enabled ? '#D7F7EA' : '#FFEAE8'} />
          )
        }
      },
      titleRender(v) {
        return (
          <div style={{wordBreak:'break-all'}}>{v||""}</div>
        )
      },
      actionRender(_: string, record) {
        if(record?.busType==='PRD_PRODUCT'&&record?.productSku&&record?.productSku?.prodType==='PRODUCT_GROUP'){
          return (
              <STableActions>
                <SActionBtn onClick={() => onDetail(record)}>组合详情</SActionBtn>
              </STableActions>
          )
        }
        if(record?.busType==='PRD_GEN_ITEM'){ //通项
          return (
              <STableActions>
                <SActionBtn onClick={() => onStandDetail(record)}>标配情况</SActionBtn>
              </STableActions>
          )
        }
      },
    },
  }
  const rowClassName = (record) => {
    const shopId = listRef?.current?.getSearch()?.getFieldValue('shopId');
    const shopIds = record?.productSku?.shopIds || [];
    //异常情况 不含通用，不包含所选门店，类型为产品，sku被删
    if((record?.productSku&&!shopIds.includes("0")&&!shopIds.includes(shopId))||(record?.busType==='PRD_PRODUCT'&&!record?.productSku)){
      return 'rowBgColor';
    }
    return "";
  };

  return (
    <KeepAlive name={location.pathname}>
      <SBack level={2} title={`${decodeURIComponent(packModelName)}-详情`}>
        <div className={styles.container}>
          <div className={styles.topBox}>
            <SAlert type="info">
              <span className={'rowBgColor'}>红色字体行</span>表示该产品SKU数据异常：打包有配置查询门店可用，但产品SKU在供应链侧该门店可能已经缺断货或下架，需要联系总部打包人员处理
            </SAlert>
          </div>
          <SLowcodeList
              searchMode={'group'} ref={listRef}
              config={{
                ...config,
                searchInitialValues
              }}
              {...extensions}
              rowClassName={rowClassName}
          />
          {/*组合详情*/}
          {
            isCombinationDetails?<CombinationDetails
                open={isCombinationDetails}
                record={currentRecord}
                onClose={() => {
                  setIsCombinationDetails(false)
                  setCurrentRecord({})
                }}
            />:null
          }
        </div>
      </SBack>
    </KeepAlive>
  )
}
export default SchemeProductDetails;
